import { AxiosResponse } from 'axios';
import { api } from 'services/companiesApi';
import axios from 'axios';

type postCommunicationProps = {
	campaignId: string;
	name: string;
	communicationTypeId: string;
	useCustomTemplate: boolean;
	messageTitle: string;
	messageBody: string;
	messageFile?: string;
	sendingDate: string;
	sendingTime: string;
};

type putCommunicationProps = {
	campaignId: string;
	communicationId: string;
	name: string;
	communicationTypeId: string;
	useCustomTemplate: boolean;
	messageTitle: string;
	messageBody: string;
	messageFile?: string;
	sendingDate: string;
	sendingTime: string;
};

type deleteCommunicationProps = {
	campaignId: string;
	communicationId: string;
};

export const getCommunications = async (
	campaignId: string,
): Promise<AxiosResponse> => {
	return await api.get(`/campaigns/${campaignId}/communications`);
};

export const getTypeCommunication = async (
	campaignId: string,
): Promise<AxiosResponse> => {
	return await api.get(`/campaigns/${campaignId}/communication-types`);
};

export const uploadCommunicationFile = async (data: any) => {
	const { urlRequest, file } = data;
	await axios.put(urlRequest, file, {
		headers: { 'Content-Type': file.type },
	});
};

export const postCommunicationService = async ({
	campaignId,
	name,
	communicationTypeId,
	useCustomTemplate,
	messageTitle,
	messageBody,
	messageFile,
	sendingDate,
	sendingTime,
}: postCommunicationProps) => {
	const postCommunication = {
		name: name,
		communicationTypeId: communicationTypeId,
		useCustomTemplate: useCustomTemplate,
		messageTitle: messageTitle,
		messageBody: messageBody,
		messageFile: messageFile,
		sendingDate: sendingDate,
		sendingTime: sendingTime,
	};

	await api.post(`/campaigns/${campaignId}/communications`, postCommunication);
};

export const putCommunicationService = async ({
	campaignId,
	communicationId,
	name,
	communicationTypeId,
	useCustomTemplate,
	messageTitle,
	messageBody,
	messageFile,
	sendingDate,
	sendingTime,
}: putCommunicationProps) => {
	const putCommunication = {
		name: name,
		communicationTypeId: communicationTypeId,
		useCustomTemplate: useCustomTemplate,
		messageTitle: messageTitle,
		messageBody: messageBody,
		messageFile: messageFile,
		sendingDate: sendingDate,
		sendingTime: sendingTime,
	};

	await api.put(
		`/campaigns/${campaignId}/communications/${communicationId}`,
		putCommunication,
	);
};

export const deleteCommunication = async ({
	campaignId,
	communicationId,
}: deleteCommunicationProps) => {
	await api.delete(
		`/campaigns/${campaignId}/communications/${communicationId}`,
	);
};
